import { useNavigate, useParams } from 'react-router-dom';
import { ArticleView } from '@/app/pages/helpcenter/HelcenterArticleView';
import { useFaqData } from '@/context/faq-data.provider';

export function ArticleRouteWrapper() {
  const { collectionSlug, articleSlug } = useParams();
  const { collections } = useFaqData();
  const navigate = useNavigate();

  const collection = collections.find((col) => col.slug === collectionSlug);
  const article = collection?.articles.find((art) => art.slug === articleSlug);

  if (!article) {
    navigate('/not-found', { replace: true });
    return null;
  }
  return <ArticleView data={article} />;
}
